import { createCustomEnum } from "./customEnum";

const TerminalOwnershipTypes = createCustomEnum({
	None: {
		name: "none",
		value: 0,
		displayName: "None",
	},
	Purchase: {
		name: "purchase",
		value: 1,
		displayName: "Purchase",
	},
	RentToOwn: {
		name: "rent_to_own",
		value: 2,
		displayName: "Rent to Own",
	},
	Rental: {
		name: "rental",
		value: 3,
		displayName: "Rental",
	},
	Reprogram: {
		name: "reprogram",
		value: 4,
		displayName: "Reprogram",
	},
	FreePlacement: {
		name: "free_placement",
		value: 5,
		displayName: "Free Placement",
	},
	Loaner: {
		name: "loaner",
		value: 6,
		displayName: "Loaner",
	},
	WarrantyProgram: {
		name: "warranty_program",
		value: 7,
		displayName: "Warranty Program",
	},
	Lease: {
		name: "lease",
		value: 8,
		displayName: "Lease",
	},
	ExistingTerminal: {
		name: "existing_terminal",
		value: 9,
		displayName: "Existing terminal",
	},
});

export default TerminalOwnershipTypes;

